import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit'
import type { RootState } from '../index'
import { setExpired } from '../slices/sessionExpirationSlice'
import { shouldShowSessionExpiredModal } from '../../features/auth/sessionExpiryWindow'

/**
 * Перехватывает AUTH_EXPIRED из RTK Query rejected actions и выставляет флаг
 * в sessionExpirationSlice. Модалка `<SessionExpiredModal/>` читает флаг и
 * показывается поверх текущей страницы.
 *
 * Идемпотентный: если `state.sessionExpiration.isExpired === true`, пропускает
 * dispatch — избегает лишних re-render'ов при 10 параллельных 401 ответах
 * (dedup работает на уровне apiClient refreshPromise, но RTK всё равно
 * dispatch'ит 10 rejected actions).
 *
 * sentryRtkMiddleware отдельно skip'ает AUTH_EXPIRED из Sentry capture —
 * expected refresh-fail flow, не bug.
 */
export const sessionExpiredMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { code?: string } | undefined
    if (payload?.code === 'AUTH_EXPIRED') {
      const state = store.getState() as RootState
      if (!state.sessionExpiration.isExpired) {
        store.dispatch(setExpired({
          shouldShowModal: shouldShowSessionExpiredModal(),
        }))
      }
    }
  }
  return next(action)
}
